"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));

var _immutable = _interopRequireDefault(require("immutable"));

var defaultState = new _immutable.default.Map({
  domain: null,
  loading: true
});

var Grader = function Grader() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _AppConstants.default.ActionTypes.RESULTS_PAGE_UNMOUNTED:
      return state.merge({
        loading: true
      });

    case _AppConstants.default.ActionTypes.WEBSITE_GRADED:
      return state.merge(action.payload).merge({
        loading: false
      });

    case _AppConstants.default.ActionTypes.WEBSITE_GRADED_ERROR:
      {
        var websiteUrl = action.payload.websiteUrl;
        return state.merge({
          domain: websiteUrl
        });
      }

    default:
      return state;
  }
};

var _default = Grader;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Grader.js
// module id = 319
// module chunks = 0